import LeadStageList from "./components/LeadStageData/LeadStageList";

const MetaStage = () => {
  return <LeadStageList />;
};

export default MetaStage;
